import React, { useRef } from 'react'
import { connect } from 'react-redux'
import styled from 'styled-components'
import { QRCodeCanvas } from 'qrcode.react'
import * as analytics from 'analytics/performance'
import { LinkStyleButton } from 'components/styled/typography'
import { I18nComponentType } from 'admin/i18n-types'
import { mapLanguageToComponentProps } from 'admin/i18n'

export interface QRCodeDownloadProps {
  size?: number
  url: string
  title?: string
  i18n: I18nComponentType
  event: { locationId: string; id: string; properties: object }
}

const QRDownloadWrapper = styled.div`
  padding: ${({ theme }) => theme.space.s16};
  display: flex;
  align-items: center;
  flex-direction: column;
  gap: ${({ theme }) => theme.space.s8};

  #hidden-qr-canvas {
    display: none;
  }
`

export const QRCodeDownload = ({
  size = 220,
  url,
  event,
  title = 'rr-share-qr-code',
  i18n,
}: QRCodeDownloadProps) => {
  const canvasRef = useRef(null)
  const onDownload = () => {
    if (canvasRef && canvasRef.current) {
      const fileName = `${title.trim().toLowerCase().replace(/ /g, '_')}_qr.png`
      const canvasRefCurrent: any = canvasRef.current
      const url = canvasRefCurrent.toDataURL('image/png', 1.0)
      const link = document.createElement('a')
      link.download = fileName || 'rr-qrcode'
      link.href = url
      link.click()
    }

    if (event) {
      analytics.onClickEvent(event)
    }
  }

  return (
    <QRDownloadWrapper>
      <QRCodeCanvas
        id="hidden-qr-canvas"
        ref={canvasRef}
        size={492}
        value={url}
      />
      <QRCodeCanvas size={size} value={url} />
      <LinkStyleButton onClick={() => onDownload()}>
        {i18n.qrCodeDownload.download}
      </LinkStyleButton>
    </QRDownloadWrapper>
  )
}

export default connect(mapLanguageToComponentProps())(QRCodeDownload)
